import { ExtensionsTable } from "@/components/shared/extensions-table";

interface ExtensionsPanelProps {
  tenantSlug: string;
}

export function ExtensionsPanel({ tenantSlug }: ExtensionsPanelProps) {
  return <ExtensionsTable tenantSlug={tenantSlug} showHeader={false} />;
}
